import React from 'react';

const TermsOfService = () => {
  console.log("TermsOfService component rendered"); // Para depuração
  return (
    <div>
      <h1>Termos de Serviço</h1>
      <p>
        Estes Termos de Serviço regem o uso do site e dos serviços oferecidos pela Siiota (Switch Industrial IoT for Automation). Ao acessar ou usar nossos serviços, você concorda em cumprir e estar vinculado a estes termos. Se você não concorda com estes termos, não deve usar nossos serviços.
      </p>

      <h2>1. Aceitação dos Termos</h2>
      <p>
        Ao acessar e utilizar nosso site e serviços, você concorda com estes Termos de Serviço e com a nossa Política de Privacidade. Nós nos reservamos o direito de modificar estes termos a qualquer momento, e as alterações terão efeito imediato após a publicação. Recomendamos que você revise estes termos periodicamente.
      </p>

      <h2>2. Uso dos Serviços</h2>
      <p>
        Os serviços fornecidos pela Siiota incluem o desenvolvimento e a oferta de software e hardware relacionados à automação industrial. Você concorda em usar nossos serviços apenas para fins legais e de acordo com todas as leis e regulamentações aplicáveis.
      </p>

      <h2>3. Responsabilidades do Usuário</h2>
      <p>
        Você é responsável por fornecer informações precisas e completas ao utilizar nossos serviços. É sua responsabilidade manter a confidencialidade de suas credenciais de acesso e notificar-nos imediatamente sobre qualquer uso não autorizado de sua conta.
      </p>

      <h2>4. Propriedade Intelectual</h2>
      <p>
        Todos os direitos de propriedade intelectual relacionados ao nosso site e aos nossos serviços, incluindo software, hardware, designs e conteúdo, são de nossa propriedade ou licenciados para nós. Você concorda em não copiar, modificar, distribuir ou criar trabalhos derivados de qualquer parte de nossos serviços sem nossa permissão expressa.
      </p>

      <h2>5. Limitação de Responsabilidade</h2>
      <p>
        Nossos serviços são fornecidos "como estão" e "conforme disponíveis". Não garantimos que nossos serviços serão ininterruptos ou livres de erros. Não seremos responsáveis por qualquer dano indireto, incidental, especial ou consequente decorrente do uso ou incapacidade de usar nossos serviços.
      </p>

      <h2>6. Modificações e Encerramento</h2>
      <p>
        Podemos modificar, suspender ou encerrar nossos serviços a qualquer momento, com ou sem aviso prévio. Se você violar estes termos, podemos suspender ou encerrar sua conta sem aviso prévio.
      </p>

      <h2>7. Links para Sites de Terceiros</h2>
      <p>
        Nosso site pode conter links para sites de terceiros que não são de nossa propriedade ou controlados por nós. Não somos responsáveis pelo conteúdo, políticas ou práticas desses sites. Recomendamos que você revise as políticas de privacidade e termos de serviço desses sites.
      </p>

      <h2>8. Jurisdição</h2>
      <p>
        Estes Termos de Serviço são regidos pelas leis brasileiras. Qualquer disputa relacionada a estes termos será resolvida no foro da comarca onde se encontra a sede da empresa.
      </p>

      <h2>9. Contato</h2>
      <p>
        Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco através dos nossos canais de atendimento.
      </p>
    </div>
  );
};

export default TermsOfService;
